import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { Rectangle, Point } from '@pixi/math';
import { settings } from '@pixi/settings';
import { EventEmitter, TextureCache, uid, getResolutionOfUrl } from '@pixi/utils';
import { ImageResource } from './resources/ImageResource.mjs';
import { BaseTexture } from './BaseTexture.mjs';
import { TextureUvs } from './TextureUvs.mjs';
var DEFAULT_UVS = new TextureUvs();
function removeAllHandlers(tex) {
  tex.destroy = function _emptyDestroy() {};
  tex.on = function _emptyOn() {};
  tex.once = function _emptyOnce() {};
  tex.emit = function _emptyEmit() {};
}
var Texture = /*#__PURE__*/function (_EventEmitter) {
  _inherits(Texture, _EventEmitter);
  var _super = _createSuper(Texture);
  function Texture(baseTexture, frame, orig, trim, rotate, anchor) {
    var _this;
    _classCallCheck(this, Texture);
    _this = _super.call(this);
    _this.noFrame = false;
    if (!frame) {
      _this.noFrame = true;
      frame = new Rectangle(0, 0, 1, 1);
    }
    if (baseTexture instanceof Texture) {
      baseTexture = baseTexture.baseTexture;
    }
    _this.baseTexture = baseTexture;
    _this._frame = frame;
    _this.trim = trim;
    _this.valid = false;
    _this._uvs = DEFAULT_UVS;
    _this.uvMatrix = null;
    _this.orig = orig || frame;
    _this._rotate = Number(rotate || 0);
    if (rotate === true) {
      _this._rotate = 2;
    } else if (_this._rotate % 2 !== 0) {
      throw new Error("attempt to use diamond-shaped UVs. If you are sure, set rotation manually");
    }
    _this.defaultAnchor = anchor ? new Point(anchor.x, anchor.y) : new Point(0, 0);
    _this._updateID = 0;
    _this.textureCacheIds = [];
    if (!baseTexture.valid) {
      baseTexture.once("loaded", _this.onBaseTextureUpdated, _assertThisInitialized(_this));
    } else if (_this.noFrame) {
      if (baseTexture.valid) {
        _this.onBaseTextureUpdated(baseTexture);
      }
    } else {
      _this.frame = frame;
    }
    if (_this.noFrame) {
      baseTexture.on("update", _this.onBaseTextureUpdated, _assertThisInitialized(_this));
    }
    return _this;
  }
  _createClass(Texture, [{
    key: "update",
    value: function update() {
      if (this.baseTexture.resource) {
        this.baseTexture.resource.update();
      }
    }
  }, {
    key: "onBaseTextureUpdated",
    value: function onBaseTextureUpdated(baseTexture) {
      if (this.noFrame) {
        if (!this.baseTexture.valid) {
          return;
        }
        this._frame.width = baseTexture.width;
        this._frame.height = baseTexture.height;
        this.valid = true;
        this.updateUvs();
      } else {
        this.frame = this._frame;
      }
      this.emit("update", this);
    }
  }, {
    key: "destroy",
    value: function destroy(destroyBase) {
      if (this.baseTexture) {
        if (destroyBase) {
          var resource = this.baseTexture.resource;
          if (resource !== null && resource !== void 0 && resource.url && TextureCache[resource.url]) {
            Texture.removeFromCache(resource.url);
          }
          this.baseTexture.destroy();
        }
        this.baseTexture.off("loaded", this.onBaseTextureUpdated, this);
        this.baseTexture.off("update", this.onBaseTextureUpdated, this);
        this.baseTexture = null;
      }
      this._frame = null;
      this._uvs = null;
      this.trim = null;
      this.orig = null;
      this.valid = false;
      Texture.removeFromCache(this);
      this.textureCacheIds = null;
    }
  }, {
    key: "clone",
    value: function clone() {
      var _this$trim;
      var clonedFrame = this._frame.clone();
      var clonedOrig = this._frame === this.orig ? clonedFrame : this.orig.clone();
      var clonedTexture = new Texture(this.baseTexture, !this.noFrame && clonedFrame, clonedOrig, (_this$trim = this.trim) === null || _this$trim === void 0 ? void 0 : _this$trim.clone(), this.rotate, this.defaultAnchor);
      if (this.noFrame) {
        clonedTexture._frame = clonedFrame;
      }
      return clonedTexture;
    }
  }, {
    key: "updateUvs",
    value: function updateUvs() {
      if (this._uvs === DEFAULT_UVS) {
        this._uvs = new TextureUvs();
      }
      this._uvs.set(this._frame, this.baseTexture, this.rotate);
      this._updateID++;
    }
  }, {
    key: "resolution",
    get: function get() {
      return this.baseTexture.resolution;
    }
  }, {
    key: "frame",
    get: function get() {
      return this._frame;
    },
    set: function set(frame) {
      this._frame = frame;
      this.noFrame = false;
      var x = frame.x,
        y = frame.y,
        width = frame.width,
        height = frame.height;
      var xNotFit = x + width > this.baseTexture.width;
      var yNotFit = y + height > this.baseTexture.height;
      if (xNotFit || yNotFit) {
        var relationship = xNotFit && yNotFit ? "and" : "or";
        var errorX = "X: ".concat(x, " + ").concat(width, " = ").concat(x + width, " > ").concat(this.baseTexture.width);
        var errorY = "Y: ".concat(y, " + ").concat(height, " = ").concat(y + height, " > ").concat(this.baseTexture.height);
        throw new Error("Texture Error: frame does not fit inside the base Texture dimensions: ".concat(errorX, " ").concat(relationship, " ").concat(errorY));
      }
      this.valid = width && height && this.baseTexture.valid;
      if (!this.trim && !this.rotate) {
        this.orig = frame;
      }
      if (this.valid) {
        this.updateUvs();
      }
    }
  }, {
    key: "rotate",
    get: function get() {
      return this._rotate;
    },
    set: function set(rotate) {
      this._rotate = rotate;
      if (this.valid) {
        this.updateUvs();
      }
    }
  }, {
    key: "width",
    get: function get() {
      return this.orig.width;
    }
  }, {
    key: "height",
    get: function get() {
      return this.orig.height;
    }
  }, {
    key: "castToBaseTexture",
    value: function castToBaseTexture() {
      return this.baseTexture;
    }
  }], [{
    key: "from",
    value: function from(source) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var strict = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : settings.STRICT_TEXTURE_CACHE;
      var isFrame = typeof source === "string";
      var cacheId = null;
      if (isFrame) {
        cacheId = source;
      } else if (source instanceof BaseTexture) {
        if (!source.cacheId) {
          var prefix = (options === null || options === void 0 ? void 0 : options.pixiIdPrefix) || "pixiid";
          source.cacheId = "".concat(prefix, "-").concat(uid());
          BaseTexture.addToCache(source, source.cacheId);
        }
        cacheId = source.cacheId;
      } else {
        if (!source._pixiId) {
          var _prefix = (options === null || options === void 0 ? void 0 : options.pixiIdPrefix) || "pixiid";
          source._pixiId = "".concat(_prefix, "_").concat(uid());
        }
        cacheId = source._pixiId;
      }
      var texture = TextureCache[cacheId];
      if (isFrame && strict && !texture) {
        throw new Error("The cacheId \"".concat(cacheId, "\" does not exist in TextureCache."));
      }
      if (!texture && !(source instanceof BaseTexture)) {
        if (!options.resolution) {
          options.resolution = getResolutionOfUrl(source);
        }
        texture = new Texture(new BaseTexture(source, options));
        texture.baseTexture.cacheId = cacheId;
        BaseTexture.addToCache(texture.baseTexture, cacheId);
        Texture.addToCache(texture, cacheId);
      } else if (!texture && source instanceof BaseTexture) {
        texture = new Texture(source);
        Texture.addToCache(texture, cacheId);
      }
      return texture;
    }
  }, {
    key: "fromURL",
    value: function fromURL(url, options) {
      var resourceOptions = Object.assign({
        autoLoad: false
      }, options === null || options === void 0 ? void 0 : options.resourceOptions);
      var texture = Texture.from(url, Object.assign({
        resourceOptions: resourceOptions
      }, options), false);
      var resource = texture.baseTexture.resource;
      if (texture.baseTexture.valid) {
        return Promise.resolve(texture);
      }
      return resource.load().then(function () {
        return Promise.resolve(texture);
      });
    }
  }, {
    key: "fromBuffer",
    value: function fromBuffer(buffer, width, height, options) {
      return new Texture(BaseTexture.fromBuffer(buffer, width, height, options));
    }
  }, {
    key: "fromLoader",
    value: function fromLoader(source, imageUrl, name, options) {
      var baseTexture = new BaseTexture(source, Object.assign({
        scaleMode: settings.SCALE_MODE,
        resolution: getResolutionOfUrl(imageUrl)
      }, options));
      var resource = baseTexture.resource;
      if (resource instanceof ImageResource) {
        resource.url = imageUrl;
      }
      var texture = new Texture(baseTexture);
      if (!name) {
        name = imageUrl;
      }
      BaseTexture.addToCache(texture.baseTexture, name);
      Texture.addToCache(texture, name);
      if (name !== imageUrl) {
        BaseTexture.addToCache(texture.baseTexture, imageUrl);
        Texture.addToCache(texture, imageUrl);
      }
      if (texture.baseTexture.valid) {
        return Promise.resolve(texture);
      }
      return new Promise(function (resolve) {
        texture.baseTexture.once("loaded", function () {
          return resolve(texture);
        });
      });
    }
  }, {
    key: "addToCache",
    value: function addToCache(texture, id) {
      if (id) {
        if (!texture.textureCacheIds.includes(id)) {
          texture.textureCacheIds.push(id);
        }
        if (TextureCache[id] && TextureCache[id] !== texture) {
          console.warn("Texture added to the cache with an id [".concat(id, "] that already had an entry"));
        }
        TextureCache[id] = texture;
      }
    }
  }, {
    key: "removeFromCache",
    value: function removeFromCache(texture) {
      if (typeof texture === "string") {
        var textureFromCache = TextureCache[texture];
        if (textureFromCache) {
          var index = textureFromCache.textureCacheIds.indexOf(texture);
          if (index > -1) {
            textureFromCache.textureCacheIds.splice(index, 1);
          }
          delete TextureCache[texture];
          return textureFromCache;
        }
      } else if (texture !== null && texture !== void 0 && texture.textureCacheIds) {
        for (var i = 0; i < texture.textureCacheIds.length; ++i) {
          if (TextureCache[texture.textureCacheIds[i]] === texture) {
            delete TextureCache[texture.textureCacheIds[i]];
          }
        }
        texture.textureCacheIds.length = 0;
        return texture;
      }
      return null;
    }
  }, {
    key: "EMPTY",
    get: function get() {
      if (!Texture._EMPTY) {
        Texture._EMPTY = new Texture(new BaseTexture());
        removeAllHandlers(Texture._EMPTY);
        removeAllHandlers(Texture._EMPTY.baseTexture);
      }
      return Texture._EMPTY;
    }
  }, {
    key: "WHITE",
    get: function get() {
      if (!Texture._WHITE) {
        var canvas = settings.ADAPTER.createCanvas(16, 16);
        var context = canvas.getContext("2d");
        canvas.width = 16;
        canvas.height = 16;
        context.fillStyle = "white";
        context.fillRect(0, 0, 16, 16);
        Texture._WHITE = new Texture(BaseTexture.from(canvas));
        removeAllHandlers(Texture._WHITE);
        removeAllHandlers(Texture._WHITE.baseTexture);
      }
      return Texture._WHITE;
    }
  }]);
  return Texture;
}(EventEmitter);
export { Texture };